export default __webpack_public_path__ + "static/media/Stormpike.3d7d52fb.jpg";